import classnames from 'classnames'
import { useRouter } from 'next/router'

export default function Tabs({ tabs, activeIndex, onChange }) {
  const router = useRouter()
  const isHome = router.asPath === '/' || router.asPath === '/en'

  return (
    <div className={classnames('tabs inlineFlex', { homeTabs: isHome })}>
      {tabs.map((tab, i) => (
        <button
          key={`${tab}`}
          className={classnames('tab', { active: activeIndex === i })}
          onClick={() => onChange(i, activeIndex)}
        >
          {tab}
        </button>
      ))}

      <style jsx>{`
        .tabs {
          position: relative;
          overflow: hidden;
          height: 5rem;
          width: 100%;
          border-radius: 2.5rem;
          background: #1a1e21;
          z-index: 1;

          &::before {
            content: '';
            position: absolute;
            z-index: 1;
            top: 0;
            left: 0;
            height: 100%;
            background: var(--primary-color);
            border-radius: 2.5rem;
            transition: transform 0.3s;
          }

          .tab {
            position: relative;
            z-index: 10;
            height: 100%;
            border-radius: inherit;
            background: transparent;
            outline: none;
            color: var(--primary-text-color);
            transition: color 0.4s;
            white-space: nowrap;
            font-size: 2.2rem;

            &:focus {
              color: var(--primary-color);
              box-shadow: inset 0 0 0 0.2rem var(--primary-color);
            }

            &.active {
              color: #fff;
              font-weight: 700;
            }
          }
        }

        @media (max-width: 1364px) {
          .tabs {
            height: 3.5rem;

            .tab {
              font-size: 1.2rem;
            }
          }
        }
      `}</style>

      <style jsx>{`
        .tabs {
          .tab {
            width: calc(100% / ${tabs.length});
          }

          &::before {
            width: calc(100% / ${tabs.length});
            transform: translateX(calc(100% * ${activeIndex}));
          }
        }
      `}</style>

      <style jsx>{`
         .tabs.homeTabs {
            display: flex;
            gap: 2.2rem;
            align-items: center;
            justify-content: center;

            height: auto;
            width: 100%;

            background: transparent;
            border-radius: 0;
            overflow: visible;
          }

          .tabs.homeTabs::before {
            content: none;
            background: none;
          }

          .tabs.homeTabs .tab {
            position: relative;
            background: transparent;
            border: 0;
            outline: none;
            cursor: pointer;
            width: fit-content;

            padding: 0.6rem 0;
            font-size: 2rem;
            font-weight: 600;

            color: rgba(255, 255, 255, 0.75);
            transition: color 0.2s ease;
          }

          .tabs.homeTabs .tab:hover {
            color: rgba(255, 255, 255, 0.95);
          }

          .tab.active {
            color: #2f80ff;
          }

          .tabs.homeTabs .tab.active::after {
            content: '';
            position: absolute;
            left: 0;
            right: 0;
            bottom: -0.2rem;
            height: 2px;
            background: #2f80ff;
            border-radius: 2px;
          }

          .tabs.homeTabs .tab:focus {
            box-shadow: none;
          }
      `}</style>
    </div>
  )
}
